import {deserialize} from "libs/cerialize";

export class ContinuedLock {
	@deserialize
	PulseDate: string;
}